import { render } from "./SingleUnitsComponent.vue?vue&type=template&id=2ae49c57"
import script from "./SingleUnitsComponent.vue?vue&type=script&lang=js"
export * from "./SingleUnitsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Desktop/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__